import * as yup from 'yup';

export const validateDecisionForm = () =>
    yup.object({
        status: yup.string().required('This field is required.'),
        reason: yup.string().when('status', {
            is: 'Denied',
            then: (schema) => schema.required('This field is required.'),
            otherwise: (schema) => schema,
        }),
        notes: yup.string(),
    });

export const validateRequestInfoForm = () =>
    yup.object({
        product: yup
            .array()
            .of(yup.string().required())
            .min(1, 'At least one product is required.')
            .required('This field is required.'),
        notes: yup.string().required('This field is required.'),
    });
